import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Selector,ImageViewer,Dialog,Toast,Modal,
  DotLoading,Ellipsis,List,Avatar,NavBar,Tabs,Grid,Image,InfiniteScroll
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import {
    GetDataDictionarysByCode,GetGuestBooks,DelGuestBooksById
  } from '../../service/service';

import { ExclamationCircleFill } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            fileList: [],
            tabIdx: 0,
            msgTypes: [],
            posts: [],
            totalCount: 0,
            page: 0,
            pageSize: 10,
            hasMore: true,
            loading: false,
            userInfo: {},
            initialLoading: false,
            visible: false,
            demoImages: [],
        };
    }

    componentDidMount() {
        var that = this;

        GetDataDictionarysByCode("LiuYanlx").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    var str = item.displayName;
                    if (str.length == 2) {
                        const chars = str.split('');
                        str = chars.join(' ');
                    }
                    arry.push({ name: str, id: item.id })
                })
                that.setState({
                    msgTypes: arry
                })
            } else {
                Toast.show({ icon: 'fail', content: '加载右侧菜单异常！' });
            }
        })

        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            this.setState({
                id: id,
            })

            this.setState({ initialLoading: true }, () => {
              this.loadPosts();
            });
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }

    loadPosts = async () => {
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数

        var that = this;
        const { page, pageSize, tabIdx, loading, hasMore, initialLoading } = this.state;
        if (!initialLoading && (loading || !hasMore)) return;

        this.setState({ loading: true });

        const data = {
            PlanetId: id,
            OpenId: "",
            MaxResultCount: pageSize,
            SkipCount: page * pageSize,
            TypeId: tabIdx === 0 ? undefined : tabIdx
        };

        try {
            GetGuestBooks(data).then(res => {
                if (res.success) {
                    var newPosts = res.result.items || [];
                    newPosts.map(item => {
                        //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        if (item.headImg != null) {
                            if (item.headImg.indexOf("https://") > -1) {
                                var urls = item.headImg.split("https://").filter(Boolean);
                                item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                            }
                        }
                        var list = [];
                        var listQNY = [];
                        item.imgs.map(item1 => {
                            const pathSegments = item1.split('/');
                            var fileName = pathSegments.filter(segment => segment).pop();
                            var qnyUrl = environment.QNYImgUrl + fileName + environment.QNYImgUrlYS;
                            listQNY.push(qnyUrl)

                            list.push(environment.apiEndpoint + item1)
                            // listQNY.push(environment.apiEndpoint + item1)
                            // list.push(environment.QNYImgUrl + fileName)
                        })
                        item.imgs = list;
                        item.imgQNYs = listQNY;
                        const creationTime = new Date(item.creationTime); 
                        const now = new Date();
                        const timeDiff = now - creationTime; // 时间差（毫秒）
                        item.creationTime = that.formatTimeDifference(timeDiff);
                    })
                    const totalCount = res.result.totalCount || 0;
                    const currentHasMore = (page * pageSize) < totalCount;

                    that.setState({
                        posts: [...this.state.posts, ...newPosts],
                        totalCount: totalCount,
                        page: page + 1,
                        hasMore: currentHasMore,
                        initialLoading: false,
                        loading: false
                    });
                } else {
                    Toast.show({ icon: 'fail', content: '加载留言信息异常！' });
                }
            })
        } catch (error) {
            Toast.show({ icon: 'fail', content: '加载留言信息异常！' });
            console.error('加载留言失败:', error);
            this.setState({
                initialLoading: false, loading: false
            });
        }
    }

    formatTimeDifference(diffInMs) {
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - diffInMs).toLocaleDateString("zh-CN");
        }
    }

    handleTabChange = (tabId) => {
        this.setState({
            tabIdx: tabId,
            posts: [],
            page: 0,
            hasMore: true
        }, () => {
            this.loadPosts();
        });
    }

    submitForm = () => {
        
    }
    
    
    showModel = () => {
        Modal.show({
            content: (
                <div style={{ textAlign: 'center', padding: '24px 16px' }}>
                    <ExclamationCircleFill
                        style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 12 }}
                    />
                    <div style={{ fontSize: 18, fontWeight: 500, color: '#333', marginBottom: 8 }}>
                        信息完善通知
            </div>
                    <div style={{ fontSize: 15, color: '#666', lineHeight: 1.5 }}>
                        请先完善基础信息！
            </div>
                    <div style={{ textAlign: "center", marginTop: "9%", textDecoration: "underline" }}>
                        <a href="javascript:;" onClick={() => {
                            Modal.clear();
                            this.props.navigate('/userEdit', { replace: true }); // 传递状态
                        }} style={{ color: "#0538ff" }}>
                            去完善</a>
                    </div>
                </div>
            ),
            // 关键修改：调整弹框样式，确保居中 + 合适宽度
            style: {
                width: 'calc(100% - 32px)', // 左右各留 16px 边距，避免贴边
                maxWidth: '400px', // 最大宽度限制（避免在大屏幕上过宽）
                zIndex: 999999999999, // 关键设置
            },
            bodyStyle: {
                borderRadius: '12px',
                margin: '0 auto', // 确保弹框水平居中
            },
            maskStyle: {
                background: 'rgba(0, 0, 0, 0.6)',
                // zIndex: 9999, // 遮罩层稍低于弹框
            },
            closeOnMaskClick: true,
            closeOnAction: false,
            actions: [],
        });
    }


    render() {
        const { posts, hasMore, loading, tabIdx, msgTypes } = this.state;

        const showDialog = (id) => {
            var that = this;
            
            Dialog.show({
                title: (
                    <div style={{
                        textAlign: 'center',
                        fontSize: 18,
                        color: '#595959',
                        padding: '8px 0',
                        marginTop: "25px",
                        fontFamily: '"STKaiti", "KaiTi", serif' // 楷体字体
                    }}>
                        <ExclamationCircleFill style={{
                            color: '#ff4d4f',
                            fontSize: 24,
                            marginRight: 8
                        }} />
                        确认删除该留言信息？
                </div>
                ),
                content: (
                    <div style={{
                        textAlign: 'center',
                        color: '#8c8c8c',
                        padding: '12px 0 16px',
                        fontSize: 14,
                        paddingBottom: "10px",
                        paddingTop: "0px",
                        fontFamily: '"STKaiti", "KaiTi", serif'
                    }}>
                        删除后将无法恢复
                </div>
                ),
                actions: [
                    [
                        {
                            key: 'cancel',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#8c8c8c',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    取 消
                      </span>
                            ),
                            style: {
                                borderRight: '1px solid #f0f0f0'
                            },
                            onClick: () => {
                                console.log('回忆已随风消散...')
                                Dialog.clear()
                            }
                        },
                        {
                            key: 'delete',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#ff4d4f',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontWeight: 'bold',
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    删 除
                      </span>
                            ),
                            onClick: () => {
                                DelGuestBooksById(id).then(res => {
                                    if (res.success) {
                                        if(res.result){
                                            // that.props.navigate('/home?planetId=' + that.state.id, {
                                            //     replace: true,
                                            //     state: { id: that.state.id }
                                            // }); // 传递状态
                                            
                                            var list = that.state.posts.filter(x => x.id != id);
                                            that.setState({
                                                posts: list,
                                            })
                                        }
                                    }
                                })

                            }
                        }
                    ]
                ],
                style: {
                    '--border-radius': '12px',
                    '--max-width': '280px',
                    '--adm-font-size-main': '16px'
                },
                bodyStyle: {
                    padding: 0
                },
                closeOnMaskClick: true,  // 新增这行，点击遮罩层可关闭
                closeOnAction: true     // 确保点击按钮后也关闭
            })
        }

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'height': "6%" }}
                >
                    留言板列表
                </NavBar>


                <div style={{
                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/3/27-08.png')"
                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "85%"
                }}>

                    <div style={{
                        width: "30px", height: "75px", position: "absolute", marginTop: "10%", right: "0%",
                        backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "4%",
                        backgroundSize: "100% 100%", writingMode: "vertical-rl", textOrientation: "upright",
                        backgroundImage: this.state.tabIdx == 0 ?
                            "url(https://api.weibinyi.com/images/niannian/3/27-15.png)"
                            : "url(https://api.weibinyi.com/images/niannian/3/27-16.png)",
                        display: "flex",          /* 使用 Flexbox 实现居中 */
                        justifyContent: "center", /* 水平居中 */
                        alignItems: "center",     /* 垂直居中 */
                        color: "#fff", fontSize: "14px"
                    }} onClick={() => this.handleTabChange(0)}
                    >
                        所 有
                    </div>

                    {
                        this.state.msgTypes.map((item, index) => {
                            var top = 10;
                            top = (index + 1) * 25 + top;
                            return (
                                <div style={{
                                    width: "30px", height: "75px", position: "absolute", marginTop: top + "%", right: "0%",
                                    backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "4%",
                                    backgroundSize: "100% 100%", writingMode: "vertical-rl", textOrientation: "upright",
                                    backgroundImage: this.state.tabIdx == item.id ?
                                        "url(https://api.weibinyi.com/images/niannian/3/27-15.png)"
                                        : "url(https://api.weibinyi.com/images/niannian/3/27-16.png)",
                                    display: "flex",          /* 使用 Flexbox 实现居中 */
                                    justifyContent: "center", /* 水平居中 */
                                    alignItems: "center",     /* 垂直居中 */
                                    color: "#fff", fontSize: "14px"
                                }} onClick={() => this.handleTabChange(item.id)}
                                >
                                    {item.name}
                                </div>
                            )
                        })
                    }


                    <div style={{ height: "30px" }}></div>

                    <div style={{ width: "78%", marginLeft: "10%", overflowY: "scroll", height: "95%" }}>

                        {
                            this.state.posts.map(item => {
                                return (
                                    <div style={{ backgroundColor: "rgb(255 255 255 / 0%)", paddingTop: "0px", borderBottom: "1px solid #a1a1a1" }}>
                                        <Grid columns={5} gap={8}>
                                            <Grid.Item span={1}>
                                                <div style={{ margin: "12px 0px 6px 12px" }}>
                                                    <Avatar src={item.headImg}
                                                        style={{ '--size': '48px', '--border-radius': '35px', 'margin': 'auto' }} />
                                                </div>
                                            </Grid.Item>
                                            <Grid.Item span={4}>
                                                <div style={{ height: "100%", paddingTop: "5%" }}>
                                                    <div style={{ fontSize: "16px", fontWeight: "600" }}>{item.familyRelationName}</div>
                                                    <div>
                                                        <span>{item.creationTime}</span>
                                                        <span style={{ marginLeft: "13%" }}>上海</span>
                                                        {
                                                            item.creatorUserId == this.state.userInfo.id ?
                                                                <>
                                                                    <span style={{ marginLeft: "17%" }} onClick={() => {
                                                                        this.props.navigate('/msgAdd', {
                                                                            replace: true, state: {
                                                                                planetId: this.state.id,
                                                                                id: item.id
                                                                            }
                                                                        }); // 传递状态
                                                                    }}>编辑</span>
                                                                    <span style={{ marginLeft: "10%" }} onClick={() => {
                                                                        showDialog(item.id);
                                                                    }}>删除</span>
                                                                </> : null
                                                        }
                                                    </div>
                                                </div>
                                            </Grid.Item>
                                        </Grid>
                                        <div style={{ padding: "0px 20px 8px 20px", fontSize: "15px" }}>
                                            <Ellipsis
                                                direction='end'
                                                content={item.remark}
                                                rows={8}
                                                expandText='展开'
                                                defaultExpanded={false}
                                                collapseText='收起'
                                                style={{
                                                    whiteSpace: 'pre-line',
                                                }}
                                            />
                                        </div>
                                        {
                                            item.imgs.length > 0 ?
                                                <div style={{ padding: "0px 20px 4px 20px" }}>
                                                    <Grid columns={3} gap={8}>
                                                        <Grid.Item span={3}>
                                                            <Image onClick={() => {
                                                                if (this.state.isClosing) {
                                                                    return;
                                                                }
                                                                this.setState({
                                                                    demoImages: item.imgs,
                                                                    visible: true
                                                                })
                                                            }}
                                                                src={item.imgQNYs[0]}
                                                                width={"98%"}
                                                                height={200}
                                                                fit='cover'
                                                                style={{ borderRadius: 4 }}
                                                            />
                                                        </Grid.Item>
                                                    </Grid>
                                                </div> : null
                                        }

                                        <div style={{ marginTop: "6px" }}>
                                            <Grid columns={3} gap={8}>
                                                <Grid.Item span={3}>
                                                    <div style={{ fontSize: "12px", paddingLeft: "20px", fontWeight: "600" }}>
                                                        <Space wrap>
                                                            <Image src={"https://api.weibinyi.com/images/niannian/3/27-14.png"}
                                                                fit='fill' width={17} height={17} />
                                                            <span style={{ color: "#7d7d7d" }}>
                                                                {
                                                                    item.creatorUserId == this.state.userInfo.id ?
                                                                        "自己" : "来自朋友 " + item.creatorUserName
                                                                }
                                                                </span>
                                                        </Space>
                                                    </div>
                                                </Grid.Item>
                                            </Grid>
                                        </div>

                                    </div>
                                )
                            })
                        }

                        {
                            this.state.page != 0 ?
                                <InfiniteScroll
                                    loadMore={this.loadPosts}
                                    hasMore={hasMore}
                                    threshold={50}
                                    initialLoad={false}
                                >
                                    {loading && (
                                        <div style={{ textAlign: 'center' }}>
                                            <DotLoading color="primary" />
                                            <span style={{ marginLeft: 8 }}>加载中...</span>
                                        </div>
                                    )}
                                    {!hasMore && (
                                        <div style={{ textAlign: 'center', color: '#999' }}>
                                            没有更多留言了
                                </div>
                                    )}
                                </InfiniteScroll> : null
                        }
                        

                    </div>



                    <div style={{
                        width: "30px", height: "75px", position: "absolute", marginBottom: "25%", right: "0%",
                        backgroundRepeat: "no-repeat", backgroundPosition: "right", marginRight: "4%",
                        backgroundSize: "100% 100%", writingMode: "vertical-rl", textOrientation: "upright",
                        backgroundImage: "url(https://api.weibinyi.com/images/niannian/3/27-22.png)",
                        display: "flex",          /* 使用 Flexbox 实现居中 */
                        justifyContent: "center", /* 水平居中 */
                        alignItems: "center",     /* 垂直居中 */
                        color: "rgb(255 75 4)", fontSize: "14px", bottom: "0"
                    }} onClick={() => {
                        if (this.state.userInfo.phone == null || this.state.userInfo.phone == "") {
                            this.showModel();
                            return;
                        }
                        this.props.navigate('/msgAdd', { replace: true, state: { planetId: this.state.id } }); // 传递状态
                    }}>
                        点击留言
                    </div>

                </div>


                <ImageViewer.Multi
                    images={this.state.demoImages}
                    visible={this.state.visible}
                    defaultIndex={0}
                    onClose={() => {
                        // this.setState({
                        //     visible: false
                        // })
                        // 标记为正在关闭
                        this.setState({ isClosing: true, visible: false }, () => {
                            // 短暂延迟后重置标记，避免影响正常打开
                            setTimeout(() => {
                                this.setState({ isClosing: false });
                            }, 300);
                        });
                    }}
                />

                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);